export var Name = 'add-catalogue-offer';
export var AddCatalogueOfferEvent = Name;